<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          
          <a-col :span="6">
            <a-form-item label="课程名称">
              <a-input placeholder="请输入" v-model="where.keyword.courseName" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="课程状态">
              <a-select defaultValue="lucy" v-model="where.keyword.status">
                <a-select-option value="0">全选</a-select-option>
                <a-select-option value="1">未发布</a-select-option>
                <a-select-option value="2">已发布</a-select-option>
                <a-select-option value="3">已关闭</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
         <a-col :span="6" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList">搜索</a-button>
          </a-col>
        </a-row>
       
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <pxkeji-btn
        name="添加"
        :roles="[]"
        class="pxkeji_basic_btn"
        @click="showInfo(0,1)"
        type="primary"
      />
      <pxkeji-btn name="导出" :roles="[]" class="pxkeji_basic_btn" />
      <pxkeji-btn name="发布" v-if="selectRows.length>0" @click="batchPublish(1)" :roles="[]" class="pxkeji_basic_btn" />
      <pxkeji-btn name="下架" v-if="selectRows.length>0" @click="batchPublish(-1)" :roles="[]" class="pxkeji_basic_btn" />
      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
        :scroll="{ x: 1300 }"
      >
        <span slot="status" slot-scope="status">
          <a-tag v-if="status==1" color="green">已发布</a-tag>
          <a-tag v-else-if="status==-1" color="red">未发布</a-tag>
          <a-tag v-else-if="status==2" color="red">直播中</a-tag>
          <a-tag v-else-if="status==3" color="green">已结束</a-tag>
          <a-tag v-else color="gray">已删除</a-tag>
        </span>
        <span slot="isRecommend" slot-scope="isRecommend">
          <a-switch
            checkedChildren="开"
            unCheckedChildren="关"
            :loading="switchLoading"
            v-model="isRecommend.isRecommend"
            @change="switchDisplay(isRecommend)"
          />
        </span>

        <span slot="action" slot-scope="action">
          <pxkeji-btn name="编辑" @click="showInfo(action.id,2)" size="small" type="primary" class="pxkeji_dro_btn" />
          <a-divider type="vertical" />
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1">
                <pxkeji-btn
                  name="删除"
                  @click="delInfo(action.id,0)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
            <!--   <a-menu-item key="2">
                <pxkeji-btn
                  name="课时管理"
                  @click="handleclassHour(action.id)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
              <a-menu-item key="3">
                <pxkeji-btn
                  name="学生明细"
                  @click="handledetails(action.id)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
               <a-menu-item key="4">
                <pxkeji-btn
                  name="SEO配置"
                  @click="setSeo(action.id)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                /> 
              </a-menu-item>-->
            </a-menu>
            <a-button size="small" type="dashed">
              更多
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>课程总数：{{list.pagination.total}}个</span>
        </div>
      </div>
    </div>

    <a-modal
      :title="info.title"
      v-model="info.visible"
      width="60%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :id="info.id" :type="info.type" />
    </a-modal>
    <a-modal
      title="SEO配置"
      v-model="seo.visible"
      width="60%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <seoComponent @callbackMethod="hide" :sourceId="seo.sourceId" :sourceType="seo.sourceType" />
    </a-modal>
    <a-modal
      title="课时管理"
      v-model="classHour.visible"
      width="80%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <classHourList @callbackMethod="save" :id="classHour.id" />
    </a-modal>
    <a-modal
      title="学生明细"
      v-model="detail.visible"
      width="80%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <studentdetaillistInfo @callbackMethod="save" :id="detail.id" />
    </a-modal>
  </div>
</template>
<script>
import Info from "./broadcastInfo.vue"; //编辑
import studentdetaillistInfo from "./studentdetaillistInfo.vue"; //学生明细
import classHourList from "./classHourList.vue"; //课时管理列表
import seoComponent from "../system/seo.vue"; //SEO
const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "课程编码"
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "课程名称"
  },

 /*  {
    dataIndex: "typeName",
    key: "typeName",
    align: "center",
    title: "课程分类"
  }, */
  {
    dataIndex: "presentPrice",
    key: "presentPrice",
    align: "center",
    title: "价格/元"
  },
  {
    dataIndex: "teacherName",
    key: "teacherName",
    align: "center",
    title: "讲师"
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
  {
    key: "isRecommend",
    align: "center",
    title: "是否推荐",
    scopedSlots: { customRender: "isRecommend" }
  },
  {
    dataIndex: "founderName",
    key: "founderName",
    align: "center",
    title: "添加人"
  },
  {
    dataIndex: "addTime",
    key: "addTime",
    align: "center",
    title: "发布日期"
  },
  {
    title: "操作",
    key: "action",
    width: 200,
    align: "center",
    scopedSlots: { customRender: "action" },
    fixed: "right"
  }
];

var that;
export default {
  name: "storelist",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          type: [],
          status: "",
          courseName: "",
          courseFrom: "",
          typeId:"",
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      info: {
        title: "",
        visible: false,
        id: 0,
        parentid: 0
      },
      seo:{
        visible: false,
        sourceId:0,
        sourceType:0
      },
      treeData: [],
      switchLoading: false, //开关等待
      classHour:{//课时管理
        visible:false,
        id: 0,
      },
      detail:{//学生明细
        visible:false
      }
    };
  },
  components: {
    Info,
    classHourList,
    studentdetaillistInfo,
    seoComponent,
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
      this.GetCateList();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    setSeo(id){
      this.seo.sourceId=id;
      this.seo.sourceType=1;
      this.seo.visible=true;
    },
    hide(){
      this.seo.visible=false;
    },
    onTimeChange(date, dateString) {
      this.where.keyword.time = dateString;
    },
    treeChange(val) {
      //console.log('tree',val)
      this.where.keyword.typeId=val[val.length-1];
      //console.log(this.where.keyword.typeId)
      //this.where.keyword.categoryId = val;
    },
    switchDisplay(e) {
      console.log(e)
      this.switchLoading = true;
      this.$api.course
        .updateRecommendById(
          e.id,
          this.$commen.changeBooleanInt(e.isRecommend)
        )
        .then(res => {
          this.switchLoading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.$message.success(res.errorMsg);
            this.GetList();
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    GetList() {
      //获取列表
     
      this.isloading = true;
      this.clearRows();
      this.$api.course
        .getPageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.typeId,
          this.where.keyword.courseName,
          this.where.keyword.courseFrom,
          1,
          this.where.keyword.status,
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
           
            res.data.records.forEach((value,index,arr) => {
              res.data.records[index].isRecommend = this.$commen.changeIntBoolean(
                value.isRecommend
              );
            });
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showInfo(id, type) {
      if(type==1){
        this.info.title='添加';
      }else if(type==2){
        this.info.title='编辑';
      }else{
        this.info.title='详情';
      }
      this.info.visible = true;
      console.log('idaa',id)
      this.info.id = id+"";
      this.info.type = type;
    },
    //发布
    batchPublish(status) {
      this.handleProhibit(this.selectRows.join(","), status);
    },
    GetCateList() {
      //获取列表
      this.isloading = true;
      this.$api.courseType
        .getTreeByColumnId('', '')
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.where.keyword.type = res.data;
            //console.log('asd',this.where.keyword.type)
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    /*批量启用 */
    // batchEnable() {
    //   this.handleProhibit(this.selectRows.join(","), 1);
    // },
    /*批量禁用 */
    // batchDisEnable() {
    //   that.handleProhibit(that.selectRows.join(","), 0);
    // },
    /*禁用启用 */
    handleProhibit(ids, status) {
      if (!status) {
        this.$confirm({
          title: "提示",
          content: "您确定要对当前记录执行"+(status==1?"发布":"下架")+"么",
          okText: "确认",
          cancelText: "取消",
          onOk() {
            that.isDisable(ids, status);
          },
          onCancel() {}
        });
      } else {
        that.isDisable(ids, status);
      }
    },
    /**禁用启用的方法 */
    isDisable(ids, status) {
      that.isloading = true;
      that.$api.course
        .updateStatusByIds(ids, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(ids,status) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.course
            .updateStatusByIds(ids,status)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    /**课时管理 */
    handleclassHour(id) {
      this.classHour.visible = true;
      this.classHour.id = id+"";
    },
    /**学生明细 */
    handledetails(id) {
      this.detail.visible = true;
      this.detail.id = id;
    },
    //子组件传值
    save() {
      this.info.visible = false;
      this.GetList();
    },
    close() {
      this.$confirm({
        title: "提示",
        content: "您确定要禁用么",
        okText: "确认",
        cancelText: "取消"
      });
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

